<goab-text tag="p" size="body-m" mt="m" mb="m" data-testid="zone-lookup-info">
  Use&nbsp;<goab-link trailingIcon="open" mt="none" mb="none"
    ><a
      data-testid="zone-lookup-map-link"
      [href]="zoneMapPdfUrl()"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-label]="zoneMapLinkAriaLabel"
      >{{ zoneMapLinkText }}</a
    ></goab-link
  >&nbsp;to check that you're in the right zone before calling.
</goab-text>

<div class="zone-select" data-testid="zone-lookup-select">
  <goab-form-item
    [label]="zoneSelectLabel"
    labelSize="large"
    [helpText]="zoneSelectHelpText"
    data-testid="zone-lookup-form-item"
  >
    <goab-dropdown
      data-testid="zone-lookup-dropdown"
      [value]="selectedZoneKey() ?? ''"
      (onChange)="onZoneChange($any($event))"
      [ariaLabel]="zoneSelectLabel"
      [native]="false"
      width="100%"
      maxWidth="100%"
      dropdownIconAccessibility
      [customAriaLabel]="zoneSelectLabel"
    >
      <goab-dropdown-item
        value=""
        [label]="zoneSelectPlaceholder"
        data-testid="zone-lookup-option-placeholder"
      ></goab-dropdown-item>
      @for (zone of zoneContacts(); track zone.key) {
      <goab-dropdown-item
        [value]="zone.key"
        [label]="zone.label"
        [attr.data-testid]="'zone-lookup-option-' + zone.key"
      ></goab-dropdown-item>
      }
    </goab-dropdown>
  </goab-form-item>
</div>

@let selected = selectedZone(); @if (selected) {
<goab-container
  type="non-interactive"
  accent="thin"
  padding="relaxed"
  mt="m"
  mb="none"
  containerShadowStyle
  data-testid="zone-lookup-contact-card"
>
  <goab-text
    tag="h3"
    size="heading-xs"
    mt="none"
    mb="xs"
    data-testid="zone-lookup-contact-title"
  >
    {{ selected.label }} contact details
  </goab-text>

  <div class="zone-phones">
    @for (phone of selected.phones; track phone; let phoneIndex = $index) {
    <goab-link leadingIcon="call" mt="none" mb="none">
      <a
        [attr.data-testid]="'zone-lookup-phone-' + phoneIndex"
        [href]="toTelHref(phone)"
      >
        {{ hydratePhoneDisplay(phone) }}
      </a>
    </goab-link>
    }
  </div>

  <goab-text
    tag="p"
    size="body-m"
    mt="xs"
    mb="none"
    data-testid="zone-lookup-hours"
  >
    {{ selected.hours }}
  </goab-text>
</goab-container>
}
